import { createContext, useContext, useState } from "react";

// One global selected country for the whole app (Discover/list, Search, Calendar).
// Persisted so the choice survives reloads. Extend the country list itself in
// lib/countries.js — nothing here needs to change to add markets.
const CountryContext = createContext(null);
const KEY = "rr_country";

export function CountryProvider({ children }) {
  const [country, setCountryState] = useState(() => {
    try {
      return localStorage.getItem(KEY) || "GB";
    } catch {
      return "GB";
    }
  });
  const setCountry = (code) => {
    setCountryState(code);
    try {
      localStorage.setItem(KEY, code);
    } catch {
      /* ignore */
    }
  };
  return (
    <CountryContext.Provider value={{ country, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  return ctx || { country: "GB", setCountry: () => {} };
}
